//General JS Utils

//Returns value of an <input> as float
import * as Globals from '../globals';
import {$layoutView, $sceneView} from "../main";

export function getValueAsFloat(inputElement) {
    return parseFloat(inputElement.value);
}

export function toFixedFloat(float, decimals = Globals.roundToDecimals) {
    return parseFloat(float.toFixed(decimals));
}

export function toFixedVector(vector, decimals = Globals.roundToDecimals) {
    vector.x = toFixedFloat(vector.x, decimals);
    vector.y = toFixedFloat(vector.y, decimals);
    vector.z = toFixedFloat(vector.z, decimals);
    return vector;
}

export function parseToFixedFloat(float, digits = Globals.roundToDecimals) {
    return parseFloat(parseFloat(float).toFixed(digits));
}

export function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

//Throttles the amount of events fired to only once every wait period
export function throttle(callback, wait) {
    let timeout;
    return function (e) {
        if (timeout) return;
        timeout = setTimeout(() => {
            callback(e);
            timeout = undefined;
        }, wait);
    };
}


export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

export function sortByKey(array, key) {
    return array.sort(function (a, b) {
        return a[key] - b[key];
    });
}

export function sortBySubKey(array, key, subkey) {
    return array.sort(function (a, b) {
        return a[key][subkey] - b[key][subkey];
    });
}

export const cursorTarget = {
    layoutView: 1,
    sceneView: 2,
    both: 3
};

export function setCursor(cursor, target = cursorTarget.layoutView) {
    switch (target) {
        case 1:
            $layoutView.css("cursor", cursor);
            break;
        case 2:
            $sceneView.css("cursor", cursor);
            break;
        case 3:
            $layoutView.css("cursor", cursor);
            $sceneView.css("cursor", cursor);
            break;
        default:
            break;
    }
}

export function getUniqueFloatArray(array) {
    array = [...new Set(array)];
    return array;
}
